import { Box, Container, Typography } from '@mui/material';

import styled from '../../styled';
import { LARGE_MARGIN_PX, MIDDLE_MARGIN_PX, SMALL_MARGIN_PX } from '../../theme';

export const CenteredContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const SearchTitle = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.common.white};
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 0;
    line-height: 1.2;
    text-align: left;

    ${({ theme }) => theme.breakpoints.up('md')} {
      font-size: 28px;
    }
  }
`;
export const SearchDescription = styled(Typography)`
  font-size: 18px;
  color: ${({ theme }) => theme.palette.common.gray};
  line-height: 1.5;
  margin-top: ${SMALL_MARGIN_PX};

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 20px;
    width: 850px;
    max-width: 100%;
    margin-top: ${MIDDLE_MARGIN_PX};
  }
`;
export const WrapperWithBorder = styled(Box)`
  padding-bottom: ${MIDDLE_MARGIN_PX};
  margin-bottom: ${MIDDLE_MARGIN_PX};
  position: relative;

  &:after {
    position: absolute;
    display: block;
    content: '';
    height: 3px;
    width: 100%;
    background-color: ${({ theme }) => theme.palette.common.violet};
    opacity: 0.3;
    left: 0;
    bottom: 0;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: ${LARGE_MARGIN_PX};
  }
`;
